import { render, staticRenderFns } from "./IncomeStatement.vue?vue&type=template&id=ed5200b6&scoped=true"
import script from "./IncomeStatement.vue?vue&type=script&lang=js"
export * from "./IncomeStatement.vue?vue&type=script&lang=js"
import style0 from "./IncomeStatement.vue?vue&type=style&index=0&id=ed5200b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5200b6",
  null
  
)

export default component.exports